module.exports = __webpack_public_path__ + "Gotham-Book.2001601357237370a424.ttf";


//////////////////
// WEBPACK FOOTER
// /code/frontend/src/assets/fonts/Gotham-Book.ttf
// module id = ../../../../../src/assets/fonts/Gotham-Book.ttf
// module chunks = 2